module.exports = __webpack_public_path__ + "static/media/welcome_bg.1d83a50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welcome_bg.png
// module id = 377
// module chunks = 21